<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div class="card o-hidden border-0 shadow my-5">
            <div class="card-body p-5">
              <div class="text-center p-5">
                <h3 class="mb-4 text-primary">Шинээр анги үүсгэx</h3>
              </div>
              <div class="row">
                <div class="col-auto">
                  <div
                    class="form-group"
                    v-for="(classRoom, index) in classData"
                    :key="index"
                  >
                    <div class="row justify-content-end">
                      <div class="col-3">
                        <label class="p-0 m-0"
                          >{{ classRoom["classIndex"] }} анги</label
                        >
                      </div>
                      <div class="col-4">
                        <input
                          v-model="classRoom['groupCount']"
                          v-bind:class="
                            classRoom['groupCount'] == 0
                              ? 'numberIsNOTGiven form-control'
                              : 'numberIsGiven form-control'
                          "
                          type="number"
                          placeholder="Бүлгийн тоо оруулаx"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row justify-content-center">
                <div class="col-4">
                  <button
                    @click="_createClassPrograms"
                    type="button"
                    class="btn btn-danger btn-block"
                  >
                    Анги үүсгэx
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");

export default {
  name: "CreateSchool",
  data() {
    return {
      uploading: false,
      uploadPercent: null,
      creatingProcent: 10,
      schoolId: " ",
      logs: ["xx", "avac"],

      groupLimit: 5, //?????
      defaultGroupLimit: 6, // angiin bulegiin default utga

      classesList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      groupList: ["а", "б", "в", "г", "д", "е", "ё", "ж", "з"],

      classData: [],
      lessonTypes: [],
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _getLessonType(typeName) {
      console.log("---");
      console.log(0, this.lessonTypes[0].type);
      console.log(1, this.lessonTypes[1].type);
      for (const i in this.lessonTypes) {
        if (typeName == this.lessonTypes[i].type) return this.lessonTypes[i];
      }
      console.log("****");
      return null;
    },
    async _findLessonTypes() {
      var types = await fb.db.collection("lessontypes").orderBy("index").get();
      if (types && !types.empty) {
        types.docs.forEach((value) => {
          let item = value.data();
          item.id = value.id;
          item.ref = value.ref;
          console.log("-----!!!!");
          this.lessonTypes.push(item);
          console.log(item);
          console.log("-----*****");
        });
      }
    },

    async _creatingSchoolProcent(procent) {
      this.creatingProcent = procent;
      setTimeout(() => {}, 10000);
    },

    async _createClassPrograms() {
      for (const i in this.classData) {
        if (this.classData[i]["groupCount"] == 0) return;
        var cls = this.classData[i];
        var newDep = {
          name: this.classData[i]["classIndex"].toString(),
          index: this.classData[i]["classIndex"],
          createdAt: new Date(),
          numberOfPrograms: parseInt(this.classData[i]["groupCount"]),
          shortName: null,
          startYear: parseInt(2021),
          description: null,
        };
        console.log(i + 1, cls["groupCount"]);
        var depRef = fb.db
          .collection("schools")
          .doc("xUSN7smB3EcLwDYhs1Y9")
          .collection("departments")
          .doc();
        await depRef.set(newDep);
        // this.logs.push("Анги " + newDep.name + " амжилттай үүслээ.");

        for (var j = 0; j < cls["groupCount"]; j++) {
          console.log(this.groupList[j]);
          if (j < this.groupList.length) {
            depRef
              .collection("programs")
              .doc()
              .set({
                name: this.groupList[j],
                index: j + 1,
                createdAt: new Date(),
              });
            this.logs.push(
              "Бүлэг " + this.groupList[j] + " амжилттай үүслээ.",
              cls["groupCount"]
            );
          }
        }
      }
    },

    _initData() {
      for (var i = 0; i < this.classesList.length; i++) {
        var cls = {
          classIndex: this.classesList[i],
          groupCount: this.defaultGroupLimit,
        };
        var rows = [];
        for (var j = 0; j < this.groupList.length; j++) {
          if (j < this.groupLimit)
            rows.push({ name: this.groupList[j], status: true });
          else rows.push({ name: this.groupList[j], status: false });
        }
        cls["groups"] = rows;
        this.classData.push(cls);
      }
    },
  },
  created() {
    this._initData();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style scoped>
.numberIsNOTGiven {
  background-color: #ed3d63 !important;
  color: white !important;
}
.numberIsGiven {
  background-color: #1cc88a !important;
  color: white !important;
}
</style>
